<script>
    import {createEventDispatcher} from "svelte";
    import department$ from "../lib/stores/department$.js";
    import location$ from "../lib/stores/location$.js";
    import {LOCATION_TYPE, ROUTE_TYPE} from "../lib/js/constants.js";
    import {hasBoatName, hasFlightNo, HM, trim, YMD} from "../lib/js/utils.js";
    import StrictLocationControl from "../lib/controls/StrictLocationControl.svelte";
    import DateControl from "../lib/controls/DateControl.svelte";
    import TimeControl from "../lib/controls/TimeControl.svelte";


    export let route;
    export let index;
    export let startDate;

    let date_at = null;
    let time_at = null;
    let showFlightNo = false;
    let showBoatName = false;
    let initialized = false;

    const dispatch = createEventDispatcher();

    const onPickupChange = ({detail}) => {
        route._pickup = detail;
        route.pickup_manually_selected = true;
        dispatch("change", {index, location: route._pickup});
    }

    const setRouteLocations = (data) => {
        let result = [];

        if (data === 'department') {
            $department$.hotels.map(hotel => {
                let location = $location$.list.find(x => x.hotel_id == hotel.id);
                if (location) {
                    result.push(location);
                }
            });
        } else if (data.length > 0) {
            data.map(id => {
                let location = $location$.list.find(x => x.id == id);
                if (location) {
                    result.push(location);
                }
            })
        }

        return result;
    }

    const initialize = () => {
        if (route.transfer_at) {
            let arr = route.transfer_at.split(' ');
            date_at = YMD(route.transfer_at);
            if (arr.length > 0) {
                time_at = HM(route.transfer_at);
            }
        }
        if (route.start_time) time_at = route.start_time;

        // set pickup locations
        if (!route._pickups) {
            route._pickups = setRouteLocations(route.pickups);
        }
        if (!route._destinations) {
            route._destinations = setRouteLocations(route.destinations);
        }

        initialized = true;
    }

    initialize();

    $: {
        if (date_at && (time_at || route.start_time)) {
            route.transfer_at = trim(`${date_at} ${time_at || route.start_time}`);
        }

        showFlightNo = hasFlightNo(route._pickup, route._drop);
        showBoatName = hasBoatName(route._pickup, route._drop);

        if (!showFlightNo && !showBoatName) {
            route.flight_no = '';
        }

        // Set the type of route
        if (route._pickup && route._drop) {
            if (route._pickup.type_id == LOCATION_TYPE.AIRPORT || route._pickup.type_id == LOCATION_TYPE.PORT) {
                route.route_type = ROUTE_TYPE.ARRIVAL;
            } else if (route._drop.type_id == LOCATION_TYPE.AIRPORT || route._drop.type_id == LOCATION_TYPE.PORT) {
                route.route_type = ROUTE_TYPE.DEPARTURE;
            } else {
                route.route_type = ROUTE_TYPE.TRANSFER;
            }
        }
    }
</script>

{#if initialized}
    <div class="row align-items-center">
        <div class="col-md-4 mb-3">
            <label>Pickup from</label>
            <StrictLocationControl bind:location={route._pickup} locations={route._pickups}
                                   placeholder="... select ..."
                                   on:change={onPickupChange} required/>
        </div>

        <div class="col-md-4">
            {#if route.allow_schedule_date == 1}
                <div class="row">
                    <div class="col-md-8 col-6 mb-3">
                        <label>Date</label>
                        <DateControl bind:value={date_at} {startDate} hideToday hideClear required/>
                    </div>
                    <div class="col-md-4 col-6 mb-3">
                        <label>Time</label>
                        <TimeControl id="date_at" bind:value={time_at} required/>
                    </div>
                </div>
            {:else}
                Exact date arranged after booking
            {/if}
        </div>

    </div>
{/if}